import { useQuery, useQueryClient } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

export interface NeighbourhoodPerk {
  buildingId: number
  category: string
  description: string | null
  id: number
  image: string | null
  link: string | null
  logo: string | null
  name: string
  position: number | null
  tag: string
  url: string | null
}

export const USE_GET_NEIGHBOURHOOD_PERKS_QUERY_KEY = 'useGetNeighbourhoodPerks'

export const getNeighbourhoodPerks = async (buildingId: number, signal?: AbortSignal) => {
  const response = await authAPI.get<NeighbourhoodPerk[]>(`/neighbourhood/building/${buildingId}`, {
    signal,
  })
  return response.data
}

export const useGetNeighbourhoodPerks = (buildingId: number) =>
  useQuery({
    queryFn: ({ signal }) => getNeighbourhoodPerks(buildingId, signal),
    queryKey: [USE_GET_NEIGHBOURHOOD_PERKS_QUERY_KEY, buildingId],
  })

export const useInvalidateNeighbourhoodPerks = () => {
  const queryClient = useQueryClient()
  return () => queryClient.invalidateQueries({ queryKey: [USE_GET_NEIGHBOURHOOD_PERKS_QUERY_KEY] })
}
